import * as React from "react";
import {
    BackButton,
    classNames,
    layout,
    theme,
    typography,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";
import {useTenant} from "./hooks";
import {useLocalization} from "../i18n";

interface ContactViewProps {
    onClose: () => void;
}

export function ContactView({onClose}: ContactViewProps) {
    const {t} = useLocalization();
    const tenant = useTenant();

    return (
        <View>
            <ViewHeader className={theme.lessContrast}>
                <ViewHeaderItem>
                    <BackButton label={t("Back")} onClick={onClose}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill className={layout.paddingMedium}>
                    <div className={typography.title}>{t("Contact")}</div>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.paddingMedium, layout.alignCenter, layout.spaceEvenly)}>
                {tenant &&
                    <div className={typography.title}>
                        <div className={layout.marginYLarge}>{tenant.name}</div>
                        {tenant.phone && <div className={layout.marginYLarge}><strong>{t("Phone")}: </strong>{tenant.phone}</div>}
                        {tenant.email && <div className={layout.marginYLarge}><strong>{t("Email")}: </strong>{tenant.email}</div>}
                    </div>
                }
            </ViewContent>
        </View>
    );
}